import { render, staticRenderFns } from "./Laboratory_screen.vue?vue&type=template&id=626bb851&scoped=true&"
import script from "./Laboratory_screen.vue?vue&type=script&lang=js&"
export * from "./Laboratory_screen.vue?vue&type=script&lang=js&"
import style0 from "./Laboratory_screen.vue?vue&type=style&index=0&id=626bb851&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626bb851",
  null
  
)

export default component.exports